import React from 'react';
import { Box, Typography } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import palette from 'src/theme/palette';

// const data = [
//   { week: 'Week 1', leads: 20 },
//   { week: 'Week 2', leads: 25 },
//   { week: 'Week 3', leads: 28 },
//   { week: 'Week 4', leads: 35 },
//   { week: 'Week 5', leads: 38 },
//   { week: 'Week 6', leads: 48 },
//   { week: 'Week 7', leads: 58 },
//   { week: 'Week 8', leads: 65 },
//   { week: 'Week 9', leads: 70 },
//   { week: 'Week 10', leads: 75 },
//   { week: 'Week 11', leads: 85 },
//   { week: 'Week 12', leads: 95 }
// ];

// Custom Tooltip component
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Box
        sx={{
          backgroundColor: 'background.paper',
          p: 1.5,
          border: `1px solid ${palette.grey[300]}`,
          borderRadius: 1,
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Typography variant="body2" sx={{ color: palette.text.primary, fontWeight: 600 }}>
          {label}
        </Typography>
        <Typography variant="body2" sx={{ color: palette.primary.barYellow, fontWeight: 600 }}>
          Leads: {payload[0]?.value}
        </Typography>
      </Box>
    );
  }
  return null;
};

const PerformanceChart = ({performance}) => {
  const chartData = performance?.data || [];
//   {{console.log('performance', performance)}}
// console.log('first week leads', performance?.data?.[0]?.leads)
// console.log('first week leads', performance?.data?.[0]?.week)
  return (
    <Box
      sx={{
        p: 3,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.08)',
        height: '100%',
        minHeight: 320
      }}
    >
      {/* Title */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: palette.text.primary,
          mb: 3
        }}
      >
        Performance Analytics
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="body2"
        sx={{
          color: palette.text.secondary,
          mb: 2,
          fontWeight: 500
        }}
      >
        Weekly Lead Growth
      </Typography>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={palette.grey[300]} vertical={false} />

          <XAxis
            dataKey="week"
            tick={{ fill: palette.text.secondary, fontSize: 12 }}
            tickLine={false}
            axisLine={{ stroke: palette.grey[300] }}
            dy={10}
          />

          <YAxis
            tick={{ fill: palette.text.secondary, fontSize: 12 }}
            tickLine={false}
            axisLine={{ stroke: palette.grey[300] }}
            domain={[0, 100]}
            ticks={[0, 20, 40, 60, 80, 100]}
          />

          <Tooltip content={<CustomTooltip />} />

          <Line
            type="monotone"
            dataKey="leads"
            stroke={palette.primary.barYellow}
            strokeWidth={3}
            dot={{ fill: palette.primary.barYellow, r: 5 }}
            activeDot={{ r: 6, fill: palette.primary.barYellow }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default PerformanceChart;